export default "__VITE_PUBLIC_ASSET__be04c408__"